import script from "./PollutionCalendar.vue?vue&type=script&setup=true&lang=js"
export * from "./PollutionCalendar.vue?vue&type=script&setup=true&lang=js"

import "./PollutionCalendar.vue?vue&type=style&index=0&id=09624a70&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-09624a70"]])

export default __exports__